import { programLabels } from "@/config";
import useGlobalConfig from "@/store/global";
import { isOctaPharmaProgram } from "@/libs/util";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { saveAs } from "file-saver";
import axios from "axios";

const PatientsHeaderButtons = () => {
  const navigate = useNavigate();
  const { program, themeColor } = useGlobalConfig();
  const isOctaPharma = isOctaPharmaProgram(program.name);
  const [downloading, setDownloading] = useState({
    pharmacy_claims: false,
    medical_claims: false,
  });

  const download = async (name: string) => {
    setDownloading({
      ...downloading,
      [name]: true,
    });
    try {
      const data = await axios.get(`downloads/${name}`, {
        responseType: "blob",
      });
      saveAs(data as any, `${name}.csv`);
    } catch (error) {
      console.error("error:", error);
    }
    setDownloading({
      ...downloading,
      [name]: false,
    });
  };

  return (
    <div>
      {
        !isOctaPharma && (
          <div className="mb-6">
            <span className="rounded-md bg-green-200 p-2 text-green-700 mb-4 inline-block text-xs md:text-base">
              Signed in as {localStorage.getItem("point_of_contact")} at{" "}
              {localStorage.getItem("business_name")}
            </span>
            <h2 className="text-2xl font-bold mb-4">
              {programLabels[program?.name]?.title}
            </h2>
            <div className="mt-3 mb-6 flex gap-x-4 flex-wrap gap-y-2">
              <Button
                type="primary"
                style={{ backgroundColor: themeColor, borderColor: themeColor }}
                onClick={() => isOctaPharma ? navigate("/assistance_requests/option") : navigate("/assistance_requests/new")}
              >
                Request Assistance for a new&nbsp;
                {programLabels[program.name]?.name}
                &nbsp;fill
              </Button>
              <Button
                type="primary"
                loading={downloading["pharmacy_claims"]}
                disabled={downloading["pharmacy_claims"]}
                className="flex gap-x-1.5 items-center"
                style={{ backgroundColor: themeColor, borderColor: themeColor }}
                onClick={() => download("pharmacy_claims")}
              >
                Download all pharmacy claims
              </Button>
              <Button
                type="primary"
                className="flex gap-x-1.5 items-center"
                loading={downloading["medical_claims"]}
                disabled={downloading["medical_claims"]}
                style={{ backgroundColor: themeColor, borderColor: themeColor }}
                onClick={() => download("medical_claims")}
              >
                Download all medical claims
              </Button>
            </div>
          </div>
        )
      }
      {isOctaPharma && (
        <div className="mt-3 mb-6 flex gap-x-4 flex-wrap gap-y-2">
          <Button
            type="primary"
            style={{ backgroundColor: themeColor, borderColor: themeColor }}
            onClick={() => isOctaPharma ? navigate("/assistance_requests/option") : navigate("/assistance_requests/new")}
          >
            Request Assistance for a new&nbsp;
            {programLabels[program.name]?.name}
            &nbsp;fill
          </Button>
          <Button
            type="primary"
            loading={downloading["pharmacy_claims"]}
            disabled={downloading["pharmacy_claims"]}
            className="flex gap-x-1.5 items-center"
            style={{ backgroundColor: themeColor, borderColor: themeColor }}
            onClick={() => download("pharmacy_claims")}
          >
            Download all pharmacy claims
          </Button>
          <Button
            type="primary"
            className="flex gap-x-1.5 items-center"
            loading={downloading["medical_claims"]}
            disabled={downloading["medical_claims"]}
            style={{ backgroundColor: themeColor, borderColor: themeColor }}
            onClick={() => download("medical_claims")}
          >
            Download all medical claims
          </Button>
        </div>
      )}
    </div>
  )
};

export default PatientsHeaderButtons;
